const ITEMS = [
    "Não gela",
    "Não liga",
    "Vazamento",
    "Barulho",
    "Placa eletrônica",
    "Frost Free",
    "Inverter",
    "Side by Side",
    "Inverse",
    "Lava e Seca",
];

const Track = ({ hidden = false }) => (
    <span className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="font-technical font-semibold uppercase tracking-[0.2em] text-lg sm:text-2xl text-white/90 px-6 sm:px-10 whitespace-nowrap">
                    {item}
                </span>
                <img
                    src="/logo-refrigelar.png"
                    alt=""
                    loading="lazy"
                    className="w-7 h-7 rounded-full shrink-0"
                />
            </span>
        ))}
    </span>
);

export const Marquee = () => (
    <div
        className="relative -rotate-1 -mx-4 bg-graphite py-4 sm:py-5 overflow-hidden shadow-[0_18px_50px_-25px_rgba(48,52,58,0.6)]"
        data-testid="marquee-band"
    >
        <div className="marquee-track">
            <Track />
            <Track hidden />
        </div>
        <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-graphite to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-graphite to-transparent pointer-events-none" />
    </div>
);
